var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFlightTravel48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18092)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.699 19.4805L34.7508 20.55C35.1454 20.9512 35.2518 21.554 35.0184 22.066L33.7704 24.8026L37.9421 37.8706C38.3212 39.0581 38.0421 40.6566 37.3231 41.7719L37.1815 41.9755L37.1044 42.0307C36.1091 42.6702 34.9323 42.3671 34.3026 41.2218L25.8996 25.9395L30.3335 22.4108C30.3967 22.3605 30.4603 22.314 30.5242 22.2713L33.699 19.4805Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4143 15.7051L26.6271 18.4933C26.5405 18.6296 26.4337 18.7652 26.3063 18.8985L22.4102 22.972L7.85468 15.2519C6.71876 14.6494 6.40177 13.483 7.03811 12.4893L7.09228 12.4109L7.2968 12.2705C8.34029 11.5975 9.80864 11.305 10.9718 11.5728L11.2161 11.6388L24.1941 15.6933L26.8937 14.5422C27.3692 14.3391 27.9187 14.4235 28.3113 14.7599L29.4143 15.7051Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3868 7.83945C42.8707 9.32329 42.8707 11.7291 41.3868 13.2129C41.3619 13.2378 41.3367 13.2624 41.3111 13.2866L21.4566 32.0669L20.816 32.7057L23.6114 42.1897L23.1796 42.6216C22.1176 43.6835 20.7031 43.4637 20.0166 42.124L15.7457 33.7855C15.6918 33.7387 15.6392 33.6896 15.5879 33.6383L15.4414 33.4809L7.10227 29.2096C5.82078 28.553 5.56397 27.2303 6.47341 26.1871L6.60467 26.0467L7.03655 25.6148L16.5192 28.4089L17.1804 27.7487L35.9398 7.91523C37.3817 6.39072 39.7865 6.32379 41.311 7.76574C41.3366 7.78996 41.3619 7.81453 41.3868 7.83945Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFlightTravel48);
export default __webpack_public_path__ + "static/media/pictogramBeaconFlightTravel48.3d5045102c808b292158628564c1c053.svg";
export { ForwardRef as ReactComponent };